module.exports = __webpack_public_path__ + "static/img/image_ktiebao@2x.5779019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbPlatformInfoMin/image_ktiebao@2x.png
// module id = 20Mj
// module chunks = 70